import React, { useState } from "react";
import { TbDownload, TbX, TbFile } from "react-icons/tb";
import PdfViewer from "./PdfViewer";

interface FilePreviewProps {
    url: string;
    fileName: string;
    onClose: () => void;
}

const getFileExtension = (name: string) => {
    const ext = name.split(".").pop()?.toLowerCase() || "";
    return ext !== name.toLowerCase() ? ext : "";
};

const FilePreview: React.FC<FilePreviewProps> = ({ url, fileName, onClose }) => {
    const ext = getFileExtension(fileName) || getFileExtension(new URL(url).pathname);
    const isImage = ["jpg", "jpeg", "png"].includes(ext);
    const isPdf = ext === "pdf";

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] flex flex-col">
                <div className="flex justify-between items-center p-4 border-b">
                    <h3 className="text-lg font-semibold truncate">{fileName}</h3>
                    <div className="flex gap-2">
                        <a href={url} target="_blank" rel="noopener noreferrer" className="p-2 text-blue-600 hover:bg-blue-50 rounded" title="Download">
                            <TbDownload size={20} />
                        </a>
                        <button onClick={onClose} className="p-2 text-gray-600 hover:bg-gray-100 rounded">
                            <TbX size={20} />
                        </button>
                    </div>
                </div>
                <div className="flex-1 overflow-auto p-4">
                    {isPdf && <PdfViewer pdfUrl={url} />}
                    {isImage && <img src={url} alt={fileName} className="max-w-full mx-auto rounded shadow" />}
                    {!isPdf && !isImage && (
                        <div className="flex flex-col items-center justify-center py-16 text-gray-500">
                            <TbFile size={64} className="mb-4 text-gray-300" />
                            <p>Pré-visualização não disponível para este tipo de arquivo.</p>
                            <a href={url} target="_blank" rel="noopener noreferrer" className="mt-4 text-blue-600 hover:underline">
                                Fazer download
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FilePreview;
